import pareja3 from '../../../assets/pareja3.jpg';

const navItems = [
  "Inicio",
  "Simulador",
  "¿Cómo funciona?",
  "Beneficios",
  "Preguntas frecuentes",
];

export default function GestionaTusCDTs() {
  return (
    <section className="w-full">
      <div className="bg-[#0346a4] text-white flex flex-col lg:flex-row">
        <div className="w-full lg:w-2/5 flex items-center justify-center px-6 sm:px-10 py-12">
          <div className="max-w-xl space-y-4">
            <p className="text-sm uppercase tracking-[0.4em] text-white/70">
              CDT
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
              Gestiona tus CDTs
            </h2>
            <p className="text-xl sm:text-2xl font-semibold text-[#e8f2f4]">
              En un solo lugar: compara, adquiere y centraliza toda tu
              información fácilmente.
            </p>
          </div>
        </div>
        <div className="w-full lg:w-3/5">
          <img
            src={pareja3}
            alt="Personas revisando sus finanzas"
            className="w-full h-72 sm:h-96 lg:h-full object-cover"
          />
        </div>
      </div>
      <div className="bg-[#e8f2f4] flex flex-wrap justify-center gap-6 sm:gap-10 lg:gap-16 px-6 sm:px-10 py-10">
        {navItems.map((label) => (
          <button
            key={label}
            type="button"
            className="text-base sm:text-lg font-bold text-[#0054c9] hover:underline focus:outline-none"
          >
            {label}
          </button>
        ))}
      </div>
    </section>
  );
}
